import request from 'superagent'
import noCache from 'superagent-no-cache'

const domain = process.env.NODE_ENV === 'local'
  ? process.env.API_HOST
  : location.protocol + '//' + location.hostname + '/api'

export const METHOD_TYPE = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
}

/**
 * XHRを実行
 * @param {string} apiPath APIのパス
 * @param {string} method Methodのタイプ
 * @param {object} params リクエストパラメータ
 * @param {object} options ヘッダーパラメータ
 * @return {Promise} リクエスト処理のPromise
 * TODO:header部分付与する。
 */
export default function callApi (apiPath, method, params = {}, options = {}) {
  // URLを生成
  const endpoint = `${domain}${apiPath}`
  const timeout = 60000
  return new Promise((resolve, reject) => {
    const req = request(method, endpoint).timeout(timeout).use(noCache).withCredentials()
    // options(header)があれば付与する
    if (options !== null) {
      Object.keys(options).forEach((key) => {
        if (options[key] !== null) {
          req.set(key, options[key])
        }
      })
    }
    // GETの場合はqueryを
    if (method === METHOD_TYPE.GET) {
      req.query(params)
    }

    // POSTの場合はbodyを
    if (method === METHOD_TYPE.POST || method === METHOD_TYPE.PUT) {
      if (typeof params.file === 'undefined') {
        req.send(params)
      } else {
        Object.keys(params).forEach((key) => {
          if (key !== 'file' && params[key] !== null) {
            req.field(key, params[key])
          }
        })
        req.attach('image', params.file)
      }
    }

    req.then((res) => {
      if (res.ok) {
        resolve(res)
      } else {
        // ajaxが失敗した
        reject(res)
      }
    }).catch((e) => {
      // ajaxが失敗した
      /* eslint-disable */
      reject({
        message: e.message,
        status: e.status,
        response: e.response
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/callApi.js